import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canUseLicenseAdmin } from '../utils/license-admin-visibility.util';

/**
 * Keeps the license console to dev builds. Pair it with `adminGuard`, which
 * stays responsible for the role check -- this one only answers "does this
 * build carry the feature at all".
 */
export const licenseAdminGuard: CanActivateFn = () => {
  if (canUseLicenseAdmin()) return true;
  // Redirect rather than deny outright, so a stale bookmark on stage or prod
  // lands somewhere sensible instead of a blank route.
  return inject(Router).createUrlTree(['/']);
};
